import { render, staticRenderFns } from "./Translations.vue?vue&type=template&id=4272f472&scoped=true&"
import script from "./Translations.vue?vue&type=script&lang=ts&"
export * from "./Translations.vue?vue&type=script&lang=ts&"
import style0 from "./Translations.vue?vue&type=style&index=0&id=4272f472&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4272f472",
  null
  
)

export default component.exports